import { prepareEventsEnum } from './modules/Metrics';
import { ProtocolTypes } from '@/modules/Metrix/types';
import { _D, CSCEVENT } from '@/modules/Metrix/misc';
import { default as H } from './modules/Metrics/classes/ValueHolder';
import { DivolteEvent } from './modules/Metrics/loaders/ClickStream';

export const PREFIX_SERVICE_EVENTS = 'SERVICE';

enum Events {
    METRIKA_FAILED = 'METRIKA_FAILED',
    CSC_FAILED = 'CSC_FAILED',
    MAIN_PAGE = 'MAIN_PAGE',
    MAIN_PAGE_BUTTON_CLICK = 'MAIN_PAGE_BUTTON_CLICK',
}

export const serviceEvents = prepareEventsEnum(PREFIX_SERVICE_EVENTS, Events);

type ProtocolsMap = Record<ProtocolTypes, unknown>;

export const serviceEventsMap: Record<Events, Partial<ProtocolsMap>> = {
    [serviceEvents.METRIKA_FAILED]: {
        [ProtocolTypes.CSC]: _D(CSCEVENT.SERVICE, 'timeout', 'metrika'),
    },
    [serviceEvents.CSC_FAILED]: {
        [ProtocolTypes.YMETRIKA]: { csc: 'timeout' },
    },
    [serviceEvents.MAIN_PAGE]: {
        [ProtocolTypes.CSC]: _D(CSCEVENT.PAGE, undefined!),
        [ProtocolTypes.YMETRIKA]: { welcome: 'show' },
    },
    [serviceEvents.MAIN_PAGE_BUTTON_CLICK]: {
        [ProtocolTypes.CSC]: _D(CSCEVENT.BUTTON, undefined!, 'continue'),
        [ProtocolTypes.YMETRIKA]: { welcome: 'continue' },
    },
};
